var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact"},[_c('div',{staticClass:"wrap contact-box"},[_c('div',{staticClass:"left"},[_c('h3',[_vm._v("联系我们")]),_c('p',[_vm._v("ADD:广东省中山市石岐街道中山二路4号星汇湾1幢16层04卡")]),_c('p',[_vm._v("TEL:13971940942")])])])])
}]

export { render, staticRenderFns }